module.exports = __webpack_public_path__ + "static/media/pipedrive.8e9ca317.png";